import { render } from "./inputDate.vue?vue&type=template&id=55a42ade&ts=true"
import script from "./inputDate.vue?vue&type=script&lang=ts"
export * from "./inputDate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__